import ListingVM from './listing-vm';
import Vue from 'vue';
import 'libs/vue-extensions';

export default {
  init : function(element) {
    let vm = new Vue(ListingVM);
    vm.bindData(JSON.parse(element.dataset.programsJson));
    vm.$mount(element);
  }
};

